import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/@services/common.service';
import { Investment, Investor } from 'src/models/investment.model';
import { CommonPagesService } from '../../common-pages.service';
import { TransactionsType } from '../../enum';

@Component({
  selector: 'app-investor-history',
  templateUrl: './investor-history.component.html',
  styleUrls: ['./investor-history.component.scss'],
  standalone: false,
})
export class InvestorHistoryComponent implements OnInit {
  //#region properties
  currentYear: number;
  lastYear: number;
  currentInvestor: Investor = { InvestorDisplayName: 'x' };
  @Input() investorSelected: string;
  @Input() isFromInvestmentsList: string;
  siteId: string;
  @Input() selectedData: Investment;
  currentYearApiInvestorsData: Investor[] = [];
  lastYearApiInvestorsData: Investor[] = [];
  multipleEmails: string[] = [];
  isVisibleTransactionModal: boolean = false;
  transactionDetails: any;
  transactionId: string = '';
  transactionType: number = TransactionsType.Investment;
  //#endregion

  constructor(
    public _cpS: CommonPagesService,
    private route: ActivatedRoute,
    private _cS: CommonService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    //get site id for URL
    this.siteId = this.route.snapshot.paramMap.get('siteId');
    this.currentYear = new Date().getFullYear();
    // this.currentInvestor = { InvestorDisplayName: 'x' };
    this.lastYear = new Date().getFullYear() - 1;
    this._cpS.currentInvestorDetails.subscribe((res: Investor) => {
      if (res != null) {
        this.currentInvestor = res;
        if (this.currentInvestor.email) {
          this.multipleEmails = this.currentInvestor.email
            .split(',')
            .map((email) => email.trim())
            .filter((email) => !!email);
        } else {
          this.multipleEmails = [];
        }
      }
    });
    this._cS.investmentHistoryRecords.subscribe(
      (res: { currentYearData; lastYearData }) => {
        if (res != null) {
          this.currentYearApiInvestorsData = res.currentYearData
            ? res.currentYearData
            : [];
          this.lastYearApiInvestorsData = res.lastYearData
            ? res.lastYearData
            : [];
        }
      }
    );
    if (
      !this.investorSelected &&
      !this.selectedData &&
      !this.isFromInvestmentsList
    ) {
      this.currentInvestor = null;
    }
  }
  navigateToActivity(year: number) {
    this._router.navigate(['/paybev/' + this.siteId + '/activity-detailed'], {
      queryParams: {
        filterYear: year,
        filterName: this.currentInvestor?.companyName,
      },
    });
  }
  openTransactionDetails(data) {
    this.isVisibleTransactionModal = true;
    this.transactionDetails = data;
    this.transactionId = data.Id;
  }
  handleCancel() {
    this.isVisibleTransactionModal = false;
  }
  //hide modal
  hideTransactionModal(event: { hide: boolean; data: object }) {
    this.isVisibleTransactionModal = event.hide;
    if (event.data) {
      // this.getSummaryDetails();
    }
  }
  getStatus(data: Investment) {
    const activityStatus = data.BrooklynInvestmentStatus;
    let status: string;
    this._cS.investmentStatus.every((element: any) => {
      if (element.statusEnum == activityStatus) {
        status = element.statusText;
        return false;
      }
      return true;
    });
    return status;
  }
}
